/*
 * @Name 商旅酒店排队订单Service
 */
import request from '../request'
import apis from '../apis'

export default {

    /** 查询巴展id */
    getBrazilExhiIDSer(param) {
        return request.get(`${apis.GET_BRAZIL_EXHI_ID}`, param)
    },
    // 查询展会下全部商旅订单
    getAllTravelHotelOrderSer(params) {
        let { pageSize, curPage, ...rest } = params
        return request.post(`${apis.FIND_ALL_BUSINESS_ORDER_PAGE_LIST}/${pageSize}/${curPage}`, rest)
    },

    /**
     * 全量商旅酒店订单导出
     * @param {exhiId} 展会ID
     */
    exportFullOrder(exhiId) {
        return request.get(`${apis.EXPORT_FULL_ORDER}`, { params: { exhiId: exhiId } });
    },

    /**
     * 获取商旅酒店订单列表（排队+预订 ）
     * @Type POST 接口
     * @param { pageSize } path参数 页大小
     * @param { curPage } path参数 当前页
     * @params { queryCondition } data主体参数 关键词
     * @params { language } data主体参数 当前语言
     * @params { exhiId } data主体参数 展会ID
     * @params { orderType } data主体参数 查询类型 orderType=2 商旅排队订单列表 orderType=1 商旅预订订单列表 orderType不传，查两类
     */
    getTravelHotelOrderSer(params) {
        let { pageSize, curPage, ...rest } = params
        return request.post(`${apis.FIND_BUSINESS_ORDER_PAGE_LIST}/${pageSize}/${curPage}`, rest)
    },

    /**
     * 获取商旅酒店订单酒店房型列表信息（排队 ）
     * @Type GET 接口
     * @params { language } query参数 当前语言
     * @params { orderHotelId } query参数 订单列表返回的 订单酒店ID
     */
    getTravelHotelOrderRoomListSer(params) {
        let newParams = {
            orderHotelId: params.orderHotelId
        }
        return request.get(`${apis.FIND_BUSINESS_ORDER_HOTEL_LIST_BY_ID}`, { params: newParams });
    },

    /**
     * 获取商旅酒店订单酒店房型列表信息（预订）
     * @Type GET 接口
     * @params { language } query参数 当前语言
     * @params { orderHotelId } query参数 订单列表返回的 订单酒店ID
     */
    getTravelHotelOrderQueuingRoomListSer(params) {
        let newParams = {
            orderHotelId: params.orderHotelId
        }
        return request.get(`${apis.FIND_ORDER_HOTEL_DETAIL_INFO}`, { params: newParams });
    },

    /**
     * 查询商旅酒店订单详情
     * @Type GET 接口
     * @params { orderId } query参数 订单列表返回的 订单iD
     */
    getTravelHotelOrderDetilSer(params) {
        let newParams = {
            orderId: params.orderId
        }
        return request.get(`${apis.FIND_BUSINESS_ORDER_DETAIL}`, { params: newParams });
    },

    /**
     * 获取商旅酒店订单导入名单李彪
     * @Type GET 接口
     * @param { pageSize } path参数 页大小
     * @param { curPage } path参数 当前页
     * @params { orderId } path参数 订单Id
     * @params { keyword } query参数 搜索关键词
     */
    getTravelHotelOrderImportCheckinSer(params) {
        let newParams = {}
        if (params.keywords) {
            newParams.keyword = params.keywords
        }
        return request.get(`${apis.FIND_IMPORT_CHECKIN}/${params.orderId}/${params.pageSize}/${params.curPage}`, { params: newParams });
    },

    /**
     * 导入锁
     */
    importLockSer(params) {
        return request.get(`${apis.IMPORT_LOCK}`, { params });
    },

    /**
     * 撤销订单导入名单
     * @Type POST 接口
     * @params { orderId } data主体参数 关键词
     * @params { memberIdList } data主体参数 当前语言
     */
    cancelRoomStayMemberSer(params) {
        let newParams = {
            orderId: params.orderId,
            memberIdList: params.memberIdList
        }
        return request.post(`${apis.CANCEL_ROOM_STAY_MEMBER}`, newParams)
    },

    /**
     * 查询商旅酒店预定订单房间入住信息导入情况，汇总值（导入了多少未导入多少）
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    getOrderCheckinImportStateSer(params) {
        return request.get(`${apis.ORDRE_CHECKIN_STATISTICS}/${params.orderId}`)
    },

    /**
     * 查询商旅酒店预定订单房间入住信息酒店列表数据
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    findHotelPageListByOrderIdSer(params) {
        return request.get(`${apis.HOTEL_PAGE_LIST_BY_ORDERID}/1000/1`, { params });
    },

    /**
     * 查询酒店下所有房型下拉数据
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    findHotelRoomPageListSer(params) {
        return request.get(`${apis.FIND_HOTEL_ROOM_PAGE_LIST}/100/1`, { params });
    },

    /**
     * 查询订单下所有地区部的数据
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    findAreaPageListSer(params) {
        return request.get(`${apis.FIND_AREA_PAGE_LIST}`, { params });
    },

    /**
     * 版本比对选择
     */
    findBusinessOrderVersionInfoSer(params) {
        return request.get(`${apis.FIND_BUSINESS_ORDER_VERSION}/${params.exhiId}/${params.orderId}`)
    },

    /**
     * 版本比对数据
     */
    findBusinessOrderVersionComparisonSer(params) {
        return request.get(`${apis.FIND_BUSINESS_ORDER_VERSION_COMPARISION}/${params.beforeVersionId}/${params.afterVersionId}`)
    },

    /**
     * 删除数据
     */
    deleteSingleSer(params) {
        return request.post(`${apis.DELETE_SINGLE}`, params)
    },

    /**
     * 加锁服务
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    findRoomStayMemberLockSer(params) {
        return request.get(`${apis.ROOM_STAY_MEMBER_LOCK}`, { params });
    },

    /**
     * 解锁服务
     * @Type GET 接口
     * @param { orderId } path参数 订单ID
     */
    findroomStayMemberUnLockSer(params) {
        return request.get(`${apis.ROOM_STAY_MEMBER_UNLOCK}`, { params });
    },

    /**
     * 查询商旅酒店预定订单房间使用情况
     * @Type GET 接口
     * @params { orderId } path参数 订单ID
     */
    getOrderRoomUseSituationSer(params) {
        return request.get(`${apis.ORDER_ROOM_USE_SITUATION}/${params.orderId}`)
    },

    /**
     * 取消订单
     * @Type GET 接口
     * @params { orderId } query参数 订单ID
     * @params { exhiId } query参数 展会ID
     */
    cancelBusinessOrderSer(params) {
        let newParams = {
            orderId: params.orderId,
            exhiId: params.exhiId
        }
        return request.get(`${apis.CANCEL_BUSINESS_ORDER}`, { params: newParams });
    },

    /**
     * 取消订单校验
     * @Type GET 接口
     * @params { orderId } query参数 订单ID
     * @params { exhiId } query参数 展会ID
     */
    checkBusinessHotelNoShowFeeSer(params) {
        return request.post(`${apis.CHECK_BUSINESS_HOTEL_NOSHOW_FEE}`, params)
    },

    /**
     * 商旅排队订单发布通知
     * @Type POST 接口
     * @params { exhiId } data主体参数 关键词
     * @params { orderId } data主体参数 当前语言
     * @params { wfStatus } data主体参数 当前语言
     * @params { remark } data主体参数 当前语言
     */
    updateBusinessOrderStutesSer(params) {
        let newParams = {
            exhiId: params.exhiId,
            orderIds: params.orderIds,
            wfStatus: params.wfStatus,
            remark: params.remark
        }
        return request.post(`${apis.UPDATE_BUSINESS_ORDER_STUTES}`, newParams)
    },

    /**
     * 导入名单导出
     * @Type GET 接口
     * @params { orderId } query参数 订单ID
     * @params { keyword } query参数 展会ID
     */
    orderCheckInExportSer(params) {
        let newParams = {
            keyword: params.keyword
        }
        return request.get(`${apis.CHECKIN_EXPORT}/${params.orderId}`, { params: newParams });
    },

    /**
     * 导入名单导出校验
     * @Type POST 接口
     */
    validEditParamSer(params) {
        return request.post(`${apis.VALID_EDIT_PARAMS}`, params)
    },

    /**
     * 导入名单导出校验
     * @Type POST 接口
     */
    memberSer(params) {
        return request.post(`${apis.MEMBER}`, params)
    },

    /**
     * 房间使用情况导出
     * @Type GET 接口
     * @params { orderId } query参数 订单ID
     */
    roomUseStatisticsExportSer(params) {
        return request.get(`${apis.USE_SITUATION_EXPORT}/${params.orderId}`)
    },

    /**
     * 导入名单导入
     * @Type POST 接口
     * @params { orderId } query参数 订单ID // 待定
     */
    orderCheckInImportSer(params) {
        let url = `${apis.IMPORT_ROOM_DATA}?ulType=${params.ulType}&excelType=${params.excelType}&exhiId=${params.exhiId}&orderId=${params.orderId}&groupNo=${params.groupNo}`
        return request.post(url, params.formData)
    },

    /**
     * 商旅酒店详情查询房型下入住人员清单
     * @Type GET 接口
     * @params { orderId } query参数 订单ID
     * @params { roomTypeId } query参数 房型ID
     */
    findBusinessOrderMemberDetailByIdSer(params) {
        let newParams = {
            orderId: params.orderId,
            roomTypeId: params.roomTypeId
        }
        return request.get(`${apis.FIND_BUSINESS_ORDER_MEMBER_DETAIL_BY_ID}`, { params: newParams });
    },
    // 查询商旅预订统计数据
    getBusinessOrderCountSer(params) {
        return request.get(`${apis.GET_BUSINESS_ORDER_COUNT}`, { params });
    },
    // 商旅预订统计导出
    exportBusinessOrderCountSer(params) {
        return request.get(`${apis.EXPORT_BUSINESS_ORDER_COUNT}`, { params });
    },
    // 商旅根据酒店ID房型ID日期范围查询实际入住量
    getRelUseInfoSer(params) {
        return request.get(`${apis.GET_REL_USE_INFO}`, { params });
    },
    // 商旅根据酒店ID房型ID日期范围查询实际入住量
    batchCreateUpdateSer(params) {
        return request.post(`${apis.BATCH_CREATE_UPDATE}`, params)
    },
    // 商旅预订统计导出客户
    exportHotelAllStayMemberSer(params) {
        let { exhiId, ...rest } = params
        return request.get(`${apis.EXPORT_HOTEL_ALL_STAY_MEMBER}/${exhiId}`, { params: rest });
    }
}
